<div kendoDialogContainer></div>
<div class="">
<div style="position: sticky;top:0;z-index: 999" *ngIf="settings.configuration.environmentName == 'staging'" class="alert alert-warning mb-0 text-center"><h5 class="mb-0">WARNING: You are currently viewing the BETA version - this is NOT the live site. Please go to <a href="https://behaviorlive.com">https://behaviorlive.com</a></h5></div>
<!--<div style="position: sticky;top:0;z-index: 999" *ngIf="settings.configuration.environmentName == 'development'" class="alert alert-warning mb-0 text-center"><h5 class="mb-0">WARNING: You are currently viewing the Development version</h5></div>-->
<router-outlet></router-outlet>
</div>


